import React from 'react';
import { OverflowWrapper } from 'app/components';
import { ArrowRight } from '@phosphor-icons/react';

export const COLUMN_CONFIG = [
  {
    'label': 'Event Name',
    'path': 'name',
    'order': 1,
    'field': 'name',
    rowElement: ({ row }) => (
      <div className="event-name flex gap-2 items-center">
        <img src={row?.image}
          width={40}
          height={40} />
        <OverflowWrapper>{row?.name}</OverflowWrapper>
      </div>
    ),
  },
  {
    'label': 'Organizer',
    'path': 'business_config_id',
    'order': 2,
    'field': 'business_config_id',
  },
  {
    'label': 'Address',
    'path': 'city',
    'order': 3,
    'field': 'city',
    rowElement: ({ row }) => (
      <OverflowWrapper>{row?.event_address?.address_line_1}</OverflowWrapper>
    ),
  },
  {
    'label': 'Date & Time',
    'path': 'start_date',
    'order': 4,
    isDate: true,
    'field': 'start_date',
  },
  {
    'label': 'Created',
    'path': 'createdAt',
    'order': 6,
    isDate: true,
    'field': 'createdAt',
  },
  {
    'label': '',
    'path': 'action_items',
    'order': 7,
    'field': 'action_items',
  },
];

export const ACTION_ITEMS = [
  { icon: <ArrowRight />, action: 'edit' },
];

